<template>
	<Modal :open="modalStatus" @close="handleClose()" align="center" animatedEnterClass="flipInX" animatedLeaveClass="fadeOut" class="ui-dialog">
		<div class="alert mB-0 bgc-white" :class="`alert-${type}`" style="margin: 0 auto; width: 500px;" role="alert">
  			<h4 class="alert-heading">{{title}}</h4>
 			<div class="text-center">
 				<i class="fa fa-check fa-4x mb-3 animated rotateIn" :class="{'fa-check': type == 'success', 'fa-exclamation-circle': type == 'warning', 'fa-question': type == 'question'}"></i>
                <p class="c-grey-900">{{ msg }}</p>
            </div>
            <div class="bdT ta-c pT-20 pB-15">
            	<button type="submit" class="btn btn-secondary mR-10" @click="handleCancel()">{{ cancelButtonText }}</button>
        		<button type="submit" class="btn btn-primary" @click="handleConfirm()" v-if="onConfirm">{{ confirmButtonText }}</button>
            </div>
		</div>
	</Modal>
</template>

<script>
    import $Lang from '@/utils/language';

	export default {
		name: 'Dialog',
		props: {
			type: {
                type: String,
                default: 'success'
            },
            title: {
                type: String,
                default: $Lang('提示')
            },
            msg: {
                type: String,
                default: $Lang('确认进行该操作?')
            },
            onConfirm: {
                type: [Function, Boolean],
                default: true
            },
            confirmButtonText: {
                type: String,
                default: $Lang('确认')
            },
            onCancel: {
                type: [Function, Boolean],
                default: null
            },
            cancelButtonText: {
                type: String,
                default: $Lang('取消')
            }
		},
		methods: {
            handleCancel () {
                this.modalStatus = false
                typeof this.onCancel === 'function' && this.onCancel()
            },
            handleConfirm () {
                this.modalStatus = false
                typeof this.onConfirm === 'function' && this.onConfirm()
            },
            handleClose () {
                this.modalStatus = false
            }
        },
        created () {
            this.$nextTick(() => {
                this.modalStatus = true
            })
        },
        data () {
            return {
                modalStatus: false
            }
        }
	}
</script>



// WEBPACK FOOTER //
// src/components/dialog/dialog.vue